export default {
  hours: state => state.hours,
  anomalies: state => state.anomalies,
  stats: state => state.stats,
  formations: state => state.formations,
  errors: state => state.errors
};
